(function () {

    'use strict';

    // NOTE ensure the namespace and any dependencies are set up appropriately, for both server and client
    if (typeof window === 'undefined') {

        module.exports = definition(require('lodash'));

    } else {

        RivalIQ.apps.Discovery.enums = definition(window._);

    }

    function definition(_) {

        const filterableDimensions = [
            {
                id: 'hashtag',
                name: 'Hashtag'
            },
            {
                id: 'mention',
                name: 'Mention'
            },
            {
                id: 'postAuthor',
                name: 'Post Author'
            },
            {
                id: 'postType',
                name: 'Post Type'
            },
            {
                id: 'sharedUrl',
                name: 'Shared Url'
            },
            {
                id: 'frequentTerm',
                name: 'Frequent Term'
            },
            {
                id: 'influencerBioTerm',
                name: 'Influencer Bio Term'
            }
        ];

        const filterableDimensionPropKeys = _.map(filterableDimensions, function (filterableDimension) {
            return `${filterableDimension.id}Filters`;
        });

        const searchTypes = {
            RECENT: 'recent',
            TOP: 'top',
            PROFILE: 'profile'
        };

        const searchTypeOptions = [
            {
                id: searchTypes.RECENT,
                hashtagSearch: true,
                name: 'Hashtag (recent posts)'
            },
            {
                id: searchTypes.TOP,
                hashtagSearch: true,
                name: 'Hashtag (top posts)'
            },
            {
                id: searchTypes.PROFILE,
                hashtagSearch: false,
                name: 'Handle'
            }
        ];

        const minNotableUsageAmount = 10;

        // gets the threshold that we count an often_used_[dimension] by; dependent on
        // total number of posts returned for the search
        const getDefaultNotableUsageAmount = function (totalNumPosts) {
            const roundToNearest = 10;
            // a fifth
            const fractionOfTotal = 5;
            return Math.max(Math.round((totalNumPosts / fractionOfTotal) / roundToNearest) * roundToNearest, minNotableUsageAmount);
        };

        const getRelaxedNotableUsageAmount = function (totalNumPosts) {
            const roundTo = 10;
            return Math.max(Math.floor(totalNumPosts / roundTo) * roundTo, minNotableUsageAmount);
        };

        return {
            filterableDimensions: filterableDimensions,
            filterableDimensionPropKeys: filterableDimensionPropKeys,
            searchTypes: searchTypes,
            searchTypeOptions: searchTypeOptions,
            getDefaultNotableUsageAmount: getDefaultNotableUsageAmount,
            getRelaxedNotableUsageAmount: getRelaxedNotableUsageAmount
        };
    }
})();
